import { useEffect } from "react";
import { SidebarProvider, useSidebar } from "../../context/SidebarContext";
import { ThemeProvider } from "../../context/ThemeContext";
import { Outlet, useLocation } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import AppHeader from "./AppHeader";
import Backdrop from "./Backdrop";
import AppSidebar from "./AppSidebar";

const LayoutContent = () => {
  const { isExpanded, isHovered, isMobileOpen } = useSidebar();
  const location = useLocation();
  const queryClient = useQueryClient();

  // À chaque changement de route dans le dashboard, on invalide la query
  // `current-user` afin de récupérer les permissions les plus à jour.
  // Combiné au polling de useCurrentUser, ça garantit que toute modification
  // des permissions côté back se reflète presque immédiatement côté front.
  useEffect(() => {
    queryClient.invalidateQueries({ queryKey: ["current-user"] });
  }, [location.pathname, queryClient]);

  return (
    <div className="min-h-screen xl:flex">
      <div>
        <AppSidebar />
        <Backdrop />
      </div>
      <div
        className={`bg-gray-50 flex-1 transition-all duration-300 ease-in-out ${
          isExpanded || isHovered ? "lg:ml-[290px]" : "lg:ml-[90px]"
        } ${isMobileOpen ? "ml-0" : ""}`}
      >
        <AppHeader />
        <div className="p-4 mx-auto max-w-(--breakpoint-2xl) md:p-6">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

const KilLayout = () => {
  return (
    <ThemeProvider>
      <SidebarProvider>
        <LayoutContent />
      </SidebarProvider>
    </ThemeProvider>
  );
};

export default KilLayout;
